export * from '@fhs/routing/src/routes/rewards/_layout';
export { default } from '@fhs/routing/src/routes/rewards/_layout';
